module.exports = __webpack_public_path__ + "img/ME.98a806f9.svg";